import React from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import ProductTabPC from '../../../../components/Sangjo-Ujieon/ProductTabPC';

const EventProcedurePC = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="상품안내" />
        <ProductTabPC />

        {/* Main Content */}
        <div className="event-procedure-main-content">
          <div className="event-procedure-page-content event-procedure-container">
            {/* Header Section */}
            <div className="event-procedure-header-section">
              <div className="event-procedure-header-text">
                <span className="event-procedure-teal-text">장례컨설팅부터 추모원까지</span> 고객님과 슬픔을 함께 나누어 드립니다.
              </div>
            </div>

            {/* Three Column Content */}
            <div className="event-procedure-content-grid">
              {/* Left Column */}
              <div className="event-procedure-column">
                <div className="event-procedure-image-container">
                  <img
                    src="/images/pa1.png"
                    alt="Day of passing"
                    className="event-procedure-image"
                  />
                </div>
                <div className="event-procedure-text-content">
                  <h3 className="event-procedure-column-title">임종일</h3>
                  <p className="event-procedure-column-text">
                    접수 및 긴급출동, 장례식장 섭외, 수시, 위패 및 제단 설치, 장례절차 협의부고안내, 화장예약
                  </p>
                </div>
                <div className="event-procedure-timeline-container">
                  <div className="event-procedure-timeline-circle">1일차</div>
                  <div className="event-procedure-timeline-connector"></div>
                </div>
              </div>

              {/* Middle Column */}
              <div className="event-procedure-column">
                <div className="event-procedure-image-container">
                  <img
                    src="/images/pa2.png"
                    alt="Day of encoffinment"
                    className="event-procedure-image"
                  />
                </div>
                <div className="event-procedure-text-content">
                  <h3 className="event-procedure-column-title">입관일</h3>
                  <p className="event-procedure-column-text">
                    입관준비, 염습/입관, 상복착용(성복례), 접객요령 안내, 도우미 배치
                  </p>
                </div>
                <div className="event-procedure-timeline-container">
                  <div className="event-procedure-timeline-circle">2일차</div>
                  <div className="event-procedure-timeline-connector"></div>
                </div>
              </div>

              {/* Right Column */}
              <div className="event-procedure-column">
                <div className="event-procedure-image-container">
                  <img
                    src="/images/pa3.png"
                    alt="Day of funeral procession"
                    className="event-procedure-image"
                  />
                </div>
                <div className="event-procedure-text-content">
                  <h3 className="event-procedure-column-title">발인일</h3>
                  <p className="event-procedure-column-text">
                    선도차 장식, 발인례/발인정산(후불정산), 장지/화장장, 제례, 혼백수습 후 귀가
                  </p>
                </div>
                <div className="event-procedure-timeline-container">
                  <div className="event-procedure-timeline-circle">3일차</div>
                </div>
              </div>
            </div>

            {/* Big Gap and Teal Line */}
            {/* <div className="event-procedure-separator-section">
              <div className="event-procedure-separator-line"></div>
            </div> */}


          </div>
        </div>
      </main>

    </div>
  );
};

export default EventProcedurePC; 